import BasePart from './BasePart'

class Oscillator extends BasePart
  constructor: (audioContext, { type = 'sine', freq = 440, destination, attack = 0, decay = 0, sustain = 0, release  = 0.3 }) ->
    super(audioContext, { destination })
    @type = type
    @freq = freq
    @attack = attack
    @decay = decay
    @sustain = sustain
    @release = release
    @instanceNode = @_createInstance()
    @connect(destination)

  _createInstance: ->
    oscillator = @audioContext.createOscillator()
    oscillator.type = @type
    oscillator.frequency.value = @freq
    @setInterface(oscillator.connect(@_createEnvelope()))
    oscillator

  _createEnvelope: ->
    envelope = @audioContext.createGain()
    envelope.gain.cancelScheduledValues(@audioContext.currentTime)
    envelope.gain.setValueAtTime(0, @audioContext.currentTime)
    envelope.gain.linearRampToValueAtTime(1, @audioContext.currentTime + @attack)
    envelope.gain.linearRampToValueAtTime(0, @audioContext.currentTime + @release)
    envelope

  setInterface: (destination) ->
    @interface = destination

  getInterface: ->
    @interface

  getInstance: ->
    @instanceNode

  setValue: (value) ->
    @freq = value
    @getInstance().frequency.value = value

  start: (time) ->
    @getInstance().start(time)

  stop: (time) ->
    @getInstance().stop(time)

  trigger: (time, length) ->
    @release = length
    @instanceNode = @_createInstance()
    @connect(@destination)
    @start(time)
    @stop(time + length)

export default Oscillator
